import { components, MenuListProps } from 'react-select';
import { SelectOption } from '../../../shared/models/form';
import useResizeObserver from '../useResizeObserver';

const CustomMenuList = ({ children, ...props }: MenuListProps<SelectOption>) => {
  const ref = useResizeObserver<HTMLDivElement>();

  return (
    <components.MenuList {...props}>
      <div ref={ref}>{children}</div>
    </components.MenuList>
  );
};

export default CustomMenuList;
